/* eslint-disable jsx-a11y/label-has-associated-control */
import { Input, Modal, Tooltip, Upload } from 'antd';
import React, { useEffect, useState } from 'react';
// import InputMask from 'react-input-mask';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
// import { ExportIcon } from 'assets/icon/dynamic';
import { log } from 'utils';
// import { colorsUpdate } from 'state/actions/configuration';
import ModalConfirmationContent from 'components/ModalConfirmationContent';
import { arrayMoveImmutable } from 'array-move';
import { DragIcon } from 'assets/icon';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { filterAccess } from 'components/Report/utils';
import ModalResetContent from 'components/ModalResetContent';
import { imgUrl } from 'utils/url';
import { ExportIcon } from 'assets/icon/dynamic';
import { configUpdate } from 'state/actions/configuration';
import './MediaConfigurationForm.css';

const MediaConfigurationForm = ({
  configuration,
  userData,
  setConfiguration,
  loading,
}) => {
  const { siteId } = useParams();

  // const [isDragged, setIsDragged] = useState(false);
  const [errors, setErrors] = useState();

  const dispatch = useDispatch();

  useEffect(() => {
    log(configuration, 'configuration');
  }, [configuration]); //eslint-disable-line
  useEffect(() => {
    setErrors();
  }, [loading]); //eslint-disable-line

  const onSubmitHandler = (event) => {
    event.preventDefault();

    log(configuration, 'poi');
    Modal.confirm({
      title: 'Confirmation',
      content: <ModalConfirmationContent />,
      onOk: () =>
        dispatch(
          configUpdate({
            ...configuration,
            siteId,
          })
        ),
    });
  };

  const onChangeDescription = (e) => {
    e.preventDefault();
    log(e, 'val description');
    const newConfig = { ...configuration };
    newConfig.medias[e.target.name].name = e.target.value;

    setConfiguration((prevState) => ({
      ...prevState,
      medias: newConfig.medias,
    }));
  };

  const onChangeColor = (val, ind) => {
    const newConfig = { ...configuration };
    newConfig.colors[ind].color = val.toHexString();

    setConfiguration((prevState) => ({
      ...prevState,
      colors: newConfig.colors,
    }));
  };

  const handleAddContent = (event) => {
    event.preventDefault();
    const newConfig = { ...configuration };
    newConfig.medias.push({ logo: null, description: '' });
    setConfiguration({ ...newConfig });
  };

  const handleDeleteTransport = (index) => {
    const newConfig = { ...configuration };
    newConfig.medias.splice(index, 1);
    setConfiguration({ ...newConfig });
  };
  // const canSubmit = poi.name && poi.description;

  const onReset = (e) => {
    e.preventDefault();

    Modal.confirm({
      title: 'Confirmation',
      content: <ModalResetContent />,
      onOk: () => {
        const newConf = {
          ...configuration,

          medias: [],
        };
        setConfiguration({ ...newConf });
      },
    });
  };

  const handleDeletePreviewImage = (index) => {
    const newConfig = { ...configuration };
    newConfig.medias[index].file = null;
    newConfig.medias[index].logo = null;
    setConfiguration((prevState) => ({
      ...prevState,
      medias: newConfig.medias,
    }));
  };
  const onFileChangedHandler = (file, index) => {
    const newConfig = { ...configuration };
    newConfig.medias[index].file = file;
    setConfiguration((prevState) => ({
      ...prevState,
      medias: newConfig.medias,
    }));
  };

  return (
    <div className="colors-form">
      <h1>Media Configuration</h1>
      <form className="form-wrapper">
        <div>
          <div className="form">
            <DragDropContext
              onDragEnd={(result) => {
                const medias = arrayMoveImmutable(
                  configuration.medias,
                  result.source.index,
                  result.destination.index
                );
                setConfiguration({ ...configuration, medias });
              }}
            >
              <DragContainer
                configuration={configuration}
                errors={errors}
                handleDeleteTransport={handleDeleteTransport}
                handleAddContent={handleAddContent}
                onChangeDescription={onChangeDescription}
                onChangeColor={onChangeColor}
                handleDeletePreviewImage={handleDeletePreviewImage}
                onFileChangedHandler={onFileChangedHandler}
                distance={1}
              />
            </DragDropContext>
            <button className="btn-outline-primary" onClick={handleAddContent}>
              Add New Media
            </button>
          </div>

          {(filterAccess({
            userData,
            siteId,
            param: 'config',
            action: 'create',
          }) ||
            filterAccess({
              userData,
              siteId,
              param: 'config',
              action: 'update',
            })) && (
            <div className="button-wrapper">
              <div>
                {loading ? (
                  <button className="button-secondary" disabled>
                    Loading...
                  </button>
                ) : (
                  <button className="button-secondary" onClick={onReset}>
                    Reset
                  </button>
                )}
                {/* <button className="button-secondary" onClick={handleReset}>
            Reset
          </button> */}
              </div>
              <div>
                {loading ? (
                  <button className="button-primary" disabled>
                    Loading...
                  </button>
                ) : (
                  <button className="button-primary" onClick={onSubmitHandler}>
                    Save & Apply
                  </button>
                )}
                {/* <button className="button-secondary" onClick={handleReset}>
            Reset
          </button> */}
              </div>
            </div>
          )}
        </div>
      </form>
    </div>
  );
};

const DragContainer = ({
  configuration,
  errors,
  handleDeleteTransport,
  onChangeDescription,
  handleDeletePreviewImage,
  onFileChangedHandler,
  onChangeColor,
}) => {
  return (
    <Droppable droppableId="droppableId">
      {(provided) => (
        <div {...provided.droppableProps} ref={provided.innerRef}>
          {configuration.medias &&
            configuration.medias.map((transport, ind) => {
              return (
                <DragElement
                  ind={ind}
                  errors={errors}
                  index={ind}
                  transport={transport}
                  onChangeDescription={onChangeDescription}
                  onChangeColor={onChangeColor}
                  handleDeleteTransport={handleDeleteTransport}
                  handleDeletePreviewImage={handleDeletePreviewImage}
                  onFileChangedHandler={onFileChangedHandler}
                />
              );
            })}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

const DragElement = ({
  ind,
  errors,
  transport,
  onChangeDescription,
  handleDeletePreviewImage,
  onFileChangedHandler,
  handleDeleteTransport,
}) => {
  const [isDragged, setIsDragged] = useState(false);
  const imagePreviewUrl = transport.file
    ? transport.file && URL.createObjectURL(transport.file)
    : transport.logo && `${imgUrl}/config/${transport.logo}`;
  return (
    <Draggable draggableId={`draggable-${ind}`} index={ind} key={ind}>
      {(provided) => (
        <div
          className="form-row"
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <DragIcon />
          <Input
            placeholder="name"
            className={`${
              errors && errors.errors && errors.errors.description
                ? 'has-error'
                : ''
            }`}
            name={ind}
            value={transport.name}
            onChange={onChangeDescription}
          />
          {imagePreviewUrl ? (
            <div className="upload-image-preview">
              <Tooltip placement="top" title="Delete">
                <button
                  type="button"
                  onClick={() => handleDeletePreviewImage(ind)}
                  className="btn-remove"
                >
                  <i className="feather-x" />
                </button>
              </Tooltip>
              <img
                className="media-avatar"
                src={imagePreviewUrl}
                alt="User profile logo preview"
              />
            </div>
          ) : (
            <Upload
              accept="image/*"
              showUploadList={false}
              beforeUpload={(file) => onFileChangedHandler(file, ind)}
            >
              <div
                onDragLeave={() => setIsDragged(false)}
                onDragOver={() => setIsDragged(true)}
                className={`upload-drag-and-drop ${isDragged ? 'active' : ''}`}
              >
                <ExportIcon size={22} color="#C2C2C2" />
                <p className="upload-title">
                  Drag or <span className="upload-highlight">Browse</span>
                </p>
                <p className="upload-subtitle">
                  File format supported: jpg, png (Up to 50MB){' '}
                </p>
              </div>
            </Upload>
          )}
          <button
            type="button"
            onClick={() => handleDeleteTransport(ind)}
            className="btn-remove"
          >
            <i className="feather-x" />
          </button>
        </div>
      )}
    </Draggable>
  );
};

export default MediaConfigurationForm;
